
export const removeTags = (input: string) => input ? input.replace(/<[^>]+>/gm, '') : '';

export const treatSpecialChars = (text: string) => {
   return text.replace(/&nbsp;/g,' ').trim().replaceAll(String.fromCharCode(13), "\\n").replaceAll("\n", "\\n");
};